// extracted by mini-css-extract-plugin
export default {"card":"DefaultMeetingCard_card__oi1ZP","header":"DefaultMeetingCard_header__xKa6u","image":"DefaultMeetingCard_image__ETJWC","btn":"DefaultMeetingCard_btn__5pt5p"};